import React from 'react';
import '../less/main.less';
import hero_img from '../img/hero_img.png';
import hero_data from '../enums/hero_data.json';
import HowToBlockNew from '../../../../../../auxiliary-components/shared/HowToBlockNew';
import howToBlockItemsData from '../enums/how_to_block_items.json';
import how_to_block_img_1 from '../img/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/how_to_block_img_3.png';
import how_to_block_img_4 from '../img/how_to_block_img_4.png';
import Hero from './../../../../../../auxiliary-components/shared/HeroBlock';
import Tabs from './../../../../../../auxiliary-components/shared/Tabs';
import CustomDropdownNew from './../../../../../../auxiliary-components/shared/CustomDropdownNew';
import europeCountriesList from "../enums/europeCountriesList.json";
import europeVisaCountriesList from "../enums/europeVisaCountriesList.json";
import asiaCountriesList from "../enums/asiaCountriesList.json";
import asiaVisaCountriesList from "../enums/asiaVisaCountriesList.json";
import usaCountriesList from "../enums/usaCountriesList.json";
import usaVisaCountriesList from "../enums/usaVisaCountriesList.json";
import africaVisaCountriesList from "../enums/africaVisaCountriesList.json";
import otherVisaCountriesList from "../enums/otherVisaCountriesList.json";
import FAQStorybook from '@abank/abank-faq';
import { filterByEnvironment } from '../../../../../../helpers/utils/environmentFilter';
import QuestionsAdminNew from './../../../../../../auxiliary-components/shared/QuestionsAdminNew';

export default function template() {
  const page = "p2p-crossborder";

  const tabs = [{tab: 'mastercard', title: 'P2P_CROSSBORDER_TABS_TITLE_01'},
          {tab: 'visa', title: 'P2P_CROSSBORDER_TABS_TITLE_02'}];

  const imagesMap = {
    how_to_block_img_1,
    how_to_block_img_2,
    how_to_block_img_3,
    how_to_block_img_4
  }

  const howToBlockItems = howToBlockItemsData.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  const renderCountries = (countries, id) => (
    <div className={`countries${id ? ` countries_${id}` : ''}`}>
      <div className="container">
        <div className="countries__body">
          {countries.map((country, index) => (
            <div key={index} className="countries__name">{this.l10n(country)}</div>
          ))}
        </div>
      </div>
    </div>
  );

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  return (
    <div className="p2p-crossborder">
      <Hero
        data={hero_data}
        img={hero_img}
        page={page}
      />
      <div className={`content${this.state.faqTab ? ' hidden' : ''}`}>
        <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} title={'P2P_CROSSBORDER_TABS_TITLE'}>
          <div>
            <CustomDropdownNew title={this.l10n("P2P_CROSSBORDER_MASTERCARD_EUROPE_TITLE")}>
              {renderCountries(europeCountriesList)}
            </CustomDropdownNew>
            <CustomDropdownNew title={this.l10n("P2P_CROSSBORDER_MASTERCARD_ASIA_TITLE")}>
              {renderCountries(asiaCountriesList)}
            </CustomDropdownNew>
            <CustomDropdownNew title={this.l10n("P2P_CROSSBORDER_MASTERCARD_USA_TITLE")}>
              {renderCountries(usaCountriesList)}
            </CustomDropdownNew>
          </div>
          <div>
            <CustomDropdownNew title={this.l10n("P2P_CROSSBORDER_VISA_EUROPE_TITLE")}>
              {renderCountries(europeVisaCountriesList)}
            </CustomDropdownNew>
            <CustomDropdownNew title={this.l10n("P2P_CROSSBORDER_VISA_ASIA_TITLE")}>
              {renderCountries(asiaVisaCountriesList)}
            </CustomDropdownNew>
            <CustomDropdownNew title={this.l10n("P2P_CROSSBORDER_VISA_USA_TITLE")}>
              {renderCountries(usaVisaCountriesList)}
            </CustomDropdownNew>
            <CustomDropdownNew title={this.l10n("P2P_CROSSBORDER_VISA_AFRICA_TITLE")}>
              {renderCountries(africaVisaCountriesList)}
            </CustomDropdownNew>
            <CustomDropdownNew title={this.l10n("P2P_CROSSBORDER_VISA_OTHER_TITLE")}>
              {renderCountries(otherVisaCountriesList, 'visa-other')}
            </CustomDropdownNew>
          </div>
        </Tabs>
        <HowToBlockNew
          items={howToBlockItems}
          title={'P2P_CROSSBORDER_HOW_TO_TITLE'}
        />
        <QuestionsAdminNew
          widget={questionsWidget}
          toggleFaqTab={this.toggleFaqTab}
          title={'P2P_CROSSBORDER_QUESTIONS_TITLE'}
          loader={this.state.loader}
        />
      </div>
      <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
        <FAQStorybook
          widget={questionsWidget}
          title={this.l10n('P2P_CROSSBORDER_FAQ_STORYBOOK_TITLE')}
          btnText={this.l10n('P2P_CROSSBORDER_FAQ_STORYBOOK_BTN_TEXT')}
          onBtnClick={this.toggleFaqTab}
          filterByEnvironment={filterByEnvironment}
        />
      </div>
    </div>
  )
}
